import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    count = 30,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.orgPartner.myOrgSearchPrePartnerList, {
        search,
        count,
    }, options);
    if (error) return { error, status };
    return content || {};
};
